import React, { useContext, useEffect } from 'react'
import { useHistory } from "react-router-dom";
import { CustomizerContext } from '@fluentui/react/lib/Utilities';
import { Image, ImageFit } from '@fluentui/react/lib/Image';
import {getTextStyles,getImageStyles} from '../styles/ErrorPage/ErrorPage.styles';
import { Stack } from '@fluentui/react/lib/Stack';
import { Text } from '@fluentui/react/lib/Text';
import backgroundImage from '../../assets/authorization-bg.png';

export default function ErrorPage() {
    let history = useHistory();

    //let backgroundImage = '../../assets/authorization-bg.png';

    useEffect(() => {
      let idToken;
      if(typeof sessionStorage !== 'undefined'){
        idToken = sessionStorage.getItem('accessToken');
      }
     
      if (idToken) {
        history.push("/StartScreen");
      }
    }, []);
    
    const theme = useContext(CustomizerContext).customizations.settings.theme;

    return (
        <Stack
        verticalFill
        verticalAlign='center'
        horizontalAlign='center'
        tokens={{ childrenGap: '1.75em' }}>
        <Image
          styles={getImageStyles(theme)}
          src={backgroundImage}
          width={332}
          height={190}
          imageFit={ImageFit.centerContain}
          alt="未授权，由于token凭证失效，暂时无法访问"
        />
        <Text styles={getTextStyles(theme)}>未授权，由于token凭证失效，暂时无法访问</Text>
      </Stack>

    )
}
